export interface IUpdateDocumentFileNameRequest {
        fileNameNoExtension: string;
        documentKey: string;
        key: any;
        type: string;
    }

    export class UpdateDocumentFileNameRequest implements IUpdateDocumentFileNameRequest {
        fileNameNoExtension: string;
        documentKey: string;
        key: any;
        type: string;

        constructor(fileNameNoExtension: string, documentKey: string, key: any, type: string) {
            this.fileNameNoExtension = fileNameNoExtension;
            this.documentKey = documentKey;
            this.key = key;
            this.type = type;
        }
    }